/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ObservableModel } from '@typescript-kit/core';

export interface TimeClockIdleViewData {
  pinCode?: string;
}

export class TimeClockIdleViewFieldKey {
  static readonly PIN_CODE = 'pinCode';
}

export class TimeClockIdleViewModel extends ObservableModel {
  static readonly KEYS = Object.keys(TimeClockIdleViewFieldKey).map((key) => TimeClockIdleViewFieldKey[key]);

  constructor(data?: TimeClockIdleViewData) {
    super(data, TimeClockIdleViewModel.KEYS);
  }

  get pinCode(): string {
    return this.get(TimeClockIdleViewFieldKey.PIN_CODE);
  }

  set pinCode(value: string) {
    this.set(TimeClockIdleViewFieldKey.PIN_CODE, value);
  }

  protected setupValues(values: TimeClockIdleViewData, exclusive: boolean): TimeClockIdleViewData {
    if (exclusive && !(TimeClockIdleViewFieldKey.PIN_CODE in values)) {
      values.pinCode = '';
    }
    return super.setupValues(values, exclusive) as TimeClockIdleViewData;
  }
}
